/** @jsxImportSource @emotion/react */
import { Table, Typography, useTheme } from '@quickbit/qb-design-system';

export const AffiliateOnboardingTable = ({
  onboarding,
}: Record<string, any>) => {
  const restructuredOnboarding: Record<string, string> = Object.entries(
    onboarding as Record<string, { value: string }[]>
  ).reduce((acc, [question, answerArray]) => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-conversion
    acc[question] = answerArray[0].value.toString();
    return acc;
  }, {});
  const { spacing } = useTheme();

  return (
    <div css={{ display: 'flex', flexDirection: 'column', gap: spacing.xxs }}>
      <Typography variant="heading2">Onboarding</Typography>
      <Table
        headers={[
          { label: 'Question', cellKey: 'question', sort: false },
          { label: 'Answer', cellKey: 'answer', sort: false },
        ]}
        rows={Object.entries(restructuredOnboarding).map(
          ([question, answer]) => ({
            value: {
              question: (
                <>
                  <Typography variant="bodyBold">{question}</Typography>
                </>
              ),
              answer: <Typography>{answer}</Typography>,
            },
          })
        )}
      />
    </div>
  );
};
